import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import OtpInput from "react-otp-input";
import { type UserConnexionResponse } from "@api/src/types/responses";
import useUser from "@app/zustand/user";

export default function WelcomeLoginRedirect() {
  const navigate = useNavigate();
  const setUser = useUser((state) => state.setUser);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [otp, setOtp] = useState("");

  function onSubmit(otp: string) {
    if (otp.length === 6) {
      setLoading(true);
      fetch(`${import.meta.env.VITE_API_URL}/user/magic-otp`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          otp,
          email: searchParams.get("email"),
        }),
      })
        .then((response) => response.json() as Promise<UserConnexionResponse>)
        .then((response) => {
          if (response.error) {
            alert(response.error);
          } else if (response.ok) {
            setUser(response.data.user);
            navigate(`/`);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    onSubmit(otp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  return (
    <>
      <p>
        Veuillez saisir le code envoyé à <b>{searchParams.get("email")}</b>
      </p>
      <div className="-mx-4 mt-12 flex w-screen items-start justify-start xs:mx-0 xs:w-full ">
        <div className="w-full max-w-[500px] overflow-hidden [&>div]:w-full [&>div]:justify-start">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={(index) => {
              if (index === 2) return <span className="mx-2">-</span>;
              return null;
            }}
            renderInput={(props, index) => {
              return (
                <input
                  {...props}
                  style={undefined}
                  inputMode="text" // hydration error without this
                  maxLength={undefined} // hydration error without this
                  className={[
                    "inline-flex h-24 w-0 shrink grow basis-0 rounded-none border border-sky-800 border-opacity-70 text-center text-[2rem] font-medium",
                    index === 0 && "!rounded-l-md border-r-0",
                    index === 1 && "",
                    index === 2 && "!rounded-r-md border-l-0",
                    index === 3 && "!rounded-l-md border-r-0",
                    index === 4 && "",
                    index === 5 && "!rounded-r-md border-l-0",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                />
              );
            }}
          />
        </div>
      </div>
      <button
        className="mr-auto mt-5 inline-block rounded-lg border-none bg-sky-800 px-10 py-2 text-white disabled:cursor-not-allowed disabled:opacity-50"
        type="submit"
        onClick={() => {
          if (otp.length < 6) return alert("Veuillez entrer le code complet");
          onSubmit(otp);
        }}
        disabled={loading}
      >
        {loading ? "Connexion..." : "Se connecter"}
      </button>
      <p className="mt-12 text-sm font-semibold italic">
        Vérifiez votre dossier de spam si vous ne trouvez pas l'email, ça peut arriver...
      </p>
    </>
  );
}
